/** @module Specification/BOM/SynchBOMFromTheme */
define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "csi/action/Controller",
    "csi/comm/PostRequest"
], function(declare,lang,Controller,PostRequest) {

	return declare(Controller, {

	        process: function() {
	            var req = this.m_action.m_request;
	            var fd = this.m_formData;
	            this.setProgress();
	            new PostRequest(req.m_module, req.m_operation)
	                .addParameter("ParentURL", this.m_urlParent)
	                .addParameter("UpdatePlacementAttributes", fd.getFieldValue("UpdatePlacementAttributes"))
	                .addParameter("ColorColorways",fd.getFieldValue("ColorColorways"))
                    .addParameter("IncludeBlankAttributes", fd.getFieldValue("IncludeBlankAttributes"))
	                .post({}).then(lang.hitch(this, this._onPublishResponse));
	        }
	    });
	});